// Doctor-management write calls (SOW §3.5). Same rationale as memberWrites: the published
// api-client doesn't yet expose CommandClient.editDoctor/deactivate/reactivate/resyncDoctorEmr (next
// batched SDK release), so we POST directly with the HttpClient auth contract until then.
import { API_ORIGIN } from "../config";

export interface DoctorProfileFields {
  first_name?: string;
  last_name?: string;
  specialty?: string;
}
export interface DoctorCredFields {
  npi?: string;
  dea_number?: string;
  license_state?: string;
  license_number?: string;
  license_expires_at?: string;
  malpractice_carrier?: string;
  malpractice_policy_no?: string;
  malpractice_expires_at?: string;
}

type GetToken = (() => Promise<string | null>) | undefined;

async function post(getToken: GetToken, path: string, body: unknown): Promise<unknown> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const token = getToken ? await getToken() : null;
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API_ORIGIN}${path}`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });
  const text = await res.text();
  const json = text ? (JSON.parse(text) as { data?: unknown; error?: { message?: string } }) : {};
  if (!res.ok) throw new Error(json.error?.message ?? "Request failed");
  return json.data;
}

export const doctorWrites = {
  edit: (
    getToken: GetToken,
    id: string,
    body: { profile?: DoctorProfileFields; credentials?: DoctorCredFields },
  ) => post(getToken, `/v1/command/doctors/${id}/edit`, body),
  approve: (getToken: GetToken, id: string) =>
    post(getToken, `/v1/command/doctors/${id}/approve`, {}),
  deactivate: (getToken: GetToken, id: string) =>
    post(getToken, `/v1/command/doctors/${id}/deactivate`, {}),
  reactivate: (getToken: GetToken, id: string) =>
    post(getToken, `/v1/command/doctors/${id}/reactivate`, {}),
  resync: (getToken: GetToken, id: string) => post(getToken, `/v1/command/doctors/${id}/resync`, {}),
};
